import { useContext } from "react";
import { CohortDetailsContext } from "../components/context/CohortDetailsProvider";

const useCohortContext = () => useContext(CohortDetailsContext);

export default useCohortContext;